import {CommandStrategy} from './base/CommandStarategy';
import {PieMenuIcons} from '../PieMenuIcons';
import {Card} from '../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../game_table/table_objects/stacks/Stack';
import {ApiSendCommandsController} from '../../../../../controllers/ApiSendCommandsController';
import {CardSelector} from '../../../../../controllers/CardSelector';
import {DynamicData} from '../../../../../data/DynamicData';

export class UnlockStacksCommandStarategy extends CommandStrategy
{
    private stack: Stack | undefined;

    constructor() {
        super({iconId: PieMenuIcons.UNL, hint: 'Unlock (L)'});
    }

    isApplicable(card: Card | undefined, stack: Stack | undefined): boolean {
        this.stack = stack;
        return !CardSelector.selectedCards.length && !!stack && stack.activeData.locked && DynamicData.settings.canTableLockCards;
    }

    execute(commandIndex: number): void {
        ApiSendCommandsController.unlockStacks([this.stack!]);
    }
}
